import axios from "axios";

export const SET_USER_INFO = "SET_USER_INFO";

function setUserInfo(user) {
	return { type: SET_USER_INFO, payload: user };
}

const getIpInfo = () => {
	return axios.get("https://ipapi.co/json");
};

const loadVisitorNew = (userId, url) => {
	return axios.post(
		"/api/cookiesData/getNew",
		{ userId, url },
		{
			headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
		}
	);
};

const newVisitor = user => {
	return axios.post("/api/cookiesData/add", user, {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const removeVisitor = email => {
	return axios.post(
		"/api/cookiesData/remove",
		{ email: email },
		{
			headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
		}
	);
};

const updateVisitor = user => {
	return axios.post("/api/cookiesData/update", user, {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

export {
	getIpInfo,
	newVisitor,
	removeVisitor,
	setUserInfo,
	updateVisitor,
	loadVisitorNew
};



// WEBPACK FOOTER //
// ./src/actions/DataCol/userdataAction.js